/*
 * Cart upsell tracking.
 *
 * Items added from the cart's upsell blocks ("You might also like" and
 * "Upsell in cart", marked with data-upsell-source) get a hidden line item
 * property: _cart_upsell = <block name>. Properties starting with "_" aren't
 * shown to shoppers in the cart or at checkout, but stay on the order, where a
 * Shopify Flow workflow tags the order "Cart upsell".
 *
 * The property goes into the add-to-cart form just before the theme reads it:
 * this listener captures the click before the button's own handler runs.
 * Products with options are added from the theme's quick-add popup, which is
 * shared by every block showing that product, so the block that last opened
 * each product's popup is remembered.
 */
(function () {
  if (window.__cartUpsellSourceInit) return;
  window.__cartUpsellSourceInit = true;

  var PROPERTY = 'properties[_cart_upsell]';
  var popupSource = {}; // product id -> block that last opened its quick-add popup

  function sourceOf(element) {
    var block = element.closest('[data-upsell-source]');
    return block ? block.getAttribute('data-upsell-source') : '';
  }

  function setProperty(form, value) {
    var input = form.querySelector('input[name="' + PROPERTY + '"]');
    if (!value) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = PROPERTY;
      form.appendChild(input);
    }
    input.value = value;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    // Opening a product's quick-add popup: remember which block opened it.
    var opener = target.closest('[data-quick-add-modal-handle]');
    if (opener) {
      var holder = opener.closest('[data-quick-add-holder]');
      var productId = holder && holder.getAttribute('data-quick-add-holder');
      if (productId) popupSource[productId] = sourceOf(opener);
      return;
    }

    var button = target.closest('[data-add-to-cart]');
    var form = button && button.closest('form');
    if (!form) return;

    var popup = button.closest('[data-quick-add-modal]');
    var source = popup ? popupSource[popup.getAttribute('data-product-id')] || '' : sourceOf(button);
    setProperty(form, source);

    // The "Upsell in cart" block sits inside the cart drawer's checkout form
    // (so its button uses that form). The theme reads the form straight
    // away, so take the marker out again afterwards rather than leave it in
    // the checkout form.
    if (source && form.matches('[data-cart-form]')) {
      setTimeout(function () { setProperty(form, ''); }, 0);
    }
  }, true);
})();
